module.exports = __webpack_public_path__ + "img/illu_upload_newmedia_4.ffe5254c.png";